import { render, staticRenderFns } from "./KeywordListHeader.vue?vue&type=template&id=60b475dd"
import script from "./KeywordListHeader.vue?vue&type=script&lang=js"
export * from "./KeywordListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports